import { useNavigate } from "react-router";
import { useAlbumStore, useProfilStore } from "../../stores/useStore";
import { observer } from "mobx-react-lite";
import FilterGroup from "../../components/album/FilterGroup";
import { HeadingIcon, Plus } from "lucide-react";
import { Minus, Infinity } from "lucide-react";
import "../../style/Play_Param.css";
import { useState, useEffect } from "react";
import Popup from "../../components/general/Popup";
import Tips from "../../components/game/Tips";

const GROUPMODE = true;
const ALLMODE = false;

const nbAlbumLimit = import.meta.env.VITE_NB_ALBUM_LIMIT;
const nbMaxHeart = import.meta.env.VITE_NB_MAX_HEART_INFINITE_MODE;
const difficultyList = [
  {
    name: "IMPOSSIBLE",
    score: "12",
    color: "#aa50eb",
    multiplicator: "5",
    shake: true,
  },
  {
    name: "Difficile",
    score: "8",
    color: "#e37173",
    multiplicator: "3",
    shake: false,
  },
  {
    name: "Normal",
    score: "4",
    color: "#329bef",
    multiplicator: "2",
    shake: false,
  },
  {
    name: "Facile",
    score: "1",
    color: "#84e567",
    multiplicator: "1",
    shake: false,
  },
];

const Param = observer(() => {
  const albumStore = useAlbumStore();
  const profilStore = useProfilStore();
  const navigate = useNavigate();

  const [nbAlbum, setNbAlbum] = useState(5);
  const [gameMode, setGameMode] = useState("date");
  const [infiniteMode, setInfiniteMode] = useState(false);
  const [nbHeart, setnbHeart] = useState(3);
  const [filterAlbumMode, setFilterAlbumMode] = useState(ALLMODE);
  const [groupFilterId, setGroupFilterId] = useState(
    albumStore
      ? albumStore.groupListSorted()[0]
        ? albumStore.groupListSorted()[0].id
        : null
      : null
  );
  // POPUPS
  const [gameruleModalIsOpen, setGameruleModalIsOpen] = useState(false);
  const [tipsModalIsOpen, setTipsModalIsOpen] = useState(false);

  const getDifficulty = () => {
    return (
      difficultyList.find(({ score }) => nbAlbum >= score) || {
        name: "Facile",
        color: "#84e567",
        multiplicator: "1",
        shake: false,
      }
    );
  };

  const handlePlay = (e) => {
    e.preventDefault(); // Empêche le rechargement
    navigate("/Play/Game", {
      state: {
        gameMode: gameMode,
        nbAlbumMax: nbAlbum,
        filterAlbumMode: filterAlbumMode,
        groupFilterId: groupFilterId,
        infiniteMode: infiniteMode,
        nbHeart: nbHeart,
        multiplicator: getDifficulty().multiplicator,
      },
    });
  };

  const updateNbAlbum = (nb) => {
    if (!isNaN(nb)) {
      let newValue = nbAlbum + nb;
      if (newValue <= 2) {
        setNbAlbum(2);
      } else if (filterAlbumMode === ALLMODE) {
        let maxValue = nbAlbumLimit;
        setNbAlbum(newValue >= maxValue ? nbAlbumLimit : newValue);
      } else if (filterAlbumMode === GROUPMODE) {
        let maxValue = albumStore.getNumberAlbumGroup({
          groupId: groupFilterId,
        });
        setNbAlbum(
          newValue > maxValue
            ? maxValue >= nbAlbumLimit
              ? nbAlbumLimit
              : maxValue
            : newValue
        );
      }
    }
  };

  const updateFilterAlbumMode = (newValue) => {
    setFilterAlbumMode(newValue);
    if (newValue === GROUPMODE) {
      let maxValue = albumStore.getNumberAlbumGroup({ groupId: groupFilterId });
      setNbAlbum(
        nbAlbum > maxValue
          ? maxValue > nbAlbumLimit
            ? nbAlbumLimit
            : maxValue
          : nbAlbum
      );
    }
  };

  const updateGroupFilter = (newGroup) => {
    setGroupFilterId(newGroup);
    if (filterAlbumMode === GROUPMODE) {
      let maxValue = albumStore.getNumberAlbumGroup({ groupId: newGroup });
      setNbAlbum(
        nbAlbum > maxValue
          ? maxValue > nbAlbumLimit
            ? nbAlbumLimit
            : maxValue
          : nbAlbum
      );
    }
  };

  const handleToggleInfiniteMode = () => {
    setInfiniteMode((prev) => prev ^ 1);
  };

  if (profilStore.isConnected === undefined) return null;
  if (!profilStore.isConnected) return null;
  let difficultyVisual = getDifficulty();
  return (
    <>
      <form
        onSubmit={(e) => handlePlay(e)}
        className={`play_param_form ${infiniteMode ? "infinite_mode" : ""}`}
      >
        <h1 className="play_param_title">
          {infiniteMode
            ? "Jouer en mode infini"
            : "Choisissez vos paramètre de jeux"}
        </h1>
        <button
          type="button"
          onClick={handleToggleInfiniteMode}
          className="play_param_infiniteModeButton"
        >
          <Infinity size={60} color="#fff" />
        </button>
        {!infiniteMode ? null : (
          <div className="play_param_heartDiv">
            <input
              value="5"
              name="rating"
              id="play_param_heart5"
              type="radio"
              checked={nbHeart === 5}
              onChange={() => setnbHeart(5)}
            />
            <label htmlFor="play_param_heart5"></label>

            <input
              value="4"
              name="rating"
              id="play_param_heart4"
              type="radio"
              checked={nbHeart === 4}
              onChange={() => setnbHeart(4)}
            />
            <label htmlFor="play_param_heart4"></label>

            <input
              value="3"
              name="rating"
              id="play_param_heart3"
              type="radio"
              checked={nbHeart === 3}
              onChange={() => setnbHeart(3)}
            />
            <label htmlFor="play_param_heart3"></label>

            <input
              value="2"
              name="rating"
              id="play_param_heart2"
              type="radio"
              checked={nbHeart === 2}
              onChange={() => setnbHeart(2)}
            />
            <label htmlFor="play_param_heart2"></label>

            <input
              value="1"
              name="rating"
              id="play_param_heart1"
              type="radio"
              checked={nbHeart === 1}
              onChange={() => setnbHeart(1)}
            />
            <label htmlFor="play_param_heart1"></label>
          </div>
        )}
        {infiniteMode ? null : (
          <div className="play_param_nbAlbumDiv">
            <p
              className={`play_param_difficultyText${
                difficultyVisual.shake ? ` shake` : ``
              }`}
              style={{ color: difficultyVisual.color }}
            >
              {difficultyVisual.name}
            </p>
            <label className="play_param_nbAlbumLabel" htmlFor="nbAlbum">
              Choisis le nombre d'albums :
            </label>
            <div className="play_param_nbAlbumSelectorDiv">
              <button
                type="button"
                className="play_param_nbAlbumMinus"
                onClick={() => updateNbAlbum(-1)}
              >
                <Minus />
              </button>
              <input
                min={1}
                className="play_param_nbAlbumInput"
                type="number"
                id="nbAlbum"
                value={nbAlbum}
                onChange={(e) => updateNbAlbum(e.target.value)}
              />
              <button
                type="button"
                className="play_param_nbAlbumPlus"
                onClick={() => updateNbAlbum(1)}
              >
                <Plus />
              </button>
            </div>
          </div>
        )}
        {infiniteMode ? null : (
          <div className="play_param_groupFilterDiv">
            <div className="play_param_groupFilterButtonDiv">
              <button
                type="button"
                className={`play_param_groupFilterAll${
                  filterAlbumMode ? `` : ` active`
                }`}
                onClick={() => updateFilterAlbumMode(ALLMODE)}
              >
                Tout les groupes
              </button>
              <button
                type="button"
                className={`play_param_groupFilterGroup${
                  filterAlbumMode ? ` active` : ``
                }`}
                onClick={() => updateFilterAlbumMode(GROUPMODE)}
              >
                Groupes
              </button>
            </div>
            <FilterGroup
              alwaysOneSelected={true}
              selectedByDefault={albumStore.groupListSorted()[0]?.id}
              groupList={albumStore.groupListSorted()}
              onSelect={
                filterAlbumMode === GROUPMODE
                  ? (group) => updateGroupFilter(group)
                  : undefined
              }
              className={`play_param_groupList ${
                filterAlbumMode === GROUPMODE ? `` : `hide`
              }`}
              tabIndex={filterAlbumMode === GROUPMODE ? true : false}
            />
          </div>
        )}
        <div className="play_param_submitDiv">
          <ul className="play_param_ruleList">
            <li>
              <button
                className="play_param_ruleButton"
                type="button"
                onClick={() => setGameruleModalIsOpen(true)}
              >
                Comment jouer
              </button>
            </li>
            <li>
              <button
                className="play_param_ruleButton"
                type="button"
                onClick={() => setTipsModalIsOpen(true)}
              >
                Astuces
              </button>
            </li>
          </ul>
          <button className="play_param_submit" type="submit">
            Lancer la partie
          </button>
        </div>
      </form>




      {/* POPUPS */}
      <Popup
        bodyOpenClassName="modal-open"
        isOpen={gameruleModalIsOpen}
        closeModal={() => setGameruleModalIsOpen(false)}
        popupTitle={"Les Règles de Tracks-List"}
      >
        <div className="play_param_popupMain">
          <p>
            Bienvenue sur{" "}
            <strong className="play_param_popupStrong">TracksList</strong> ! Ici, ton
            job est simple : remettre des albums dans le bon ordre, comme
            une timeline.
          </p>

          <p>
            À chaque tour, un album s'affiche devant toi. Tu dois le glisser{" "}
            <strong className="play_param_popupStrong">entre les autres</strong> pour
            dire : « Cet album est sorti entre celui-là et celui-là. »
          </p>

          <p>
            Si tu as bon : bravo, tu avances sans souci, en gagnant des points.
            Les point sont calculer en fonctions de nombreux paramètres, le mode de jeu, la difficulté, le nombre de vie, etc.
            Si tu te plantes :
            l'album est replacé au bon endroit, et tu{" "}
            <strong className="play_param_popupStrong">perds une vie, ou tu ne gagne pas de points</strong>.
          </p>

          <p>
            Ton score dépend du nombre total d'albums et d’un multiplicateur. Tu commences à
            0, mais chaque bonne réponse te fais gagner des points.{" "}
            <strong className="play_param_popupStrong">
              Plus tu te trompes, moins tu gagne de points
            </strong>
            .
          </p>

          <p>
            Et n'oublie pas : quand tu n'est pas en mode infinite, un chrono tourne. Quand il est à zéro, c’est la
            fin.
          </p>

          <p>
            Plusieurs paramètres sont à ta disposition, tu es libre de créer ta propre partie,
             un mode infinite existe et il permet 
          </p>

          <p>
            Quand c’est fini, tu peux relancer une partie, regarder ton
            classement, ou changer de mode de jeu.
          </p>

          <p>Bonne chance!</p>
        </div>
      </Popup>
      <Popup
        bodyOpenClassName="modal-open"
        isOpen={tipsModalIsOpen}
        closeModal={() => setTipsModalIsOpen(false)}
        popupTitle={"Astuce"}
      >
        <Tips className="play_param_popupMain" />
      </Popup>
    </>
  );
});

export default Param;
